/// <amd-module name="Build/Admin/Pool/Components/RunningJobsSeries" />
import * as ChartSeries from "Analytics/Shared/ChartSeries/ChartSeries";
import * as ChartDataConverter from "Analytics/Shared/Common/Utils/ChartDataConverter";
import * as Colors from "Build/Admin/Pool/Colors";
import * as Resources from "Build/Admin/Pool/Resources";

export class RunningJobsSeries extends ChartSeries.ChartSeries {
    public get name(): string {
        return Resources.RunningJobs;
    }

    public get color(): string {
        return Colors.RunningJobsColorPalette;
    }

    public get values(): number[] {
        return ChartDataConverter.formatData(this._data);
    }
}
